import BaseSnackbar from '@material-ui/core/Snackbar'

const Snackbar = BaseSnackbar

export default Snackbar
